import React from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import { useModal } from "../../../Store/modules/modal/modal";
import settings from "../../../settings/settings";
import WhiteLogo from "../../Icons/white-logo.png";
import Logo from "../../Icons/logo_small2X.png";
import { useTheme, useThemeColors } from "../../../Store/modules/theme";
import { Div, Icon, Text } from "../../Kit";
import { useCheckLogin } from "../../../Store/modules/auth/checkLogin";
import { Pages } from "../../../Constants/pages";
import { useLanguage } from "../../../Store/modules/language";
import { Home3 } from "iconsax-react";
import { GetModelListDataTypes } from "../../../Schema/checkLogin.types";

export const AIModelsModal: React.FC = () => {
  const { modalProps, dispatchCloseModal } = useModal();
  const { third_party_models } = modalProps || {};
  const { name: themeStatus } = useTheme();
  const [theme] = useThemeColors();
  const { checkLoginData } = useCheckLogin();
  const { direction } = useLanguage();
  const { has_subscription } = checkLoginData?.data || {};
  const navigateToSubscription = () => {
    if (!has_subscription) {
      dispatchCloseModal();
      modalProps.router(Pages.Subscription);
    }
  };

  return (
    <Modal
      modalName={ModalNames.AIModelsModal}
      showCloseIcon
      modalClassName="xs:w-[360px] md:w-[1100px] md:h-auto xs:h-[90%] rounded-[5px] overflow-y-auto hide-scrollbar"
    >
      <Div className="text-center">
        {themeStatus === "dark" ? (
          <img
            src={settings?.logo?.dark ?? WhiteLogo}
            alt="logo"
            className="w-[40px] pt-[4px] mx-auto"
          />
        ) : (
          <img
            src={settings?.logo?.light ?? Logo}
            alt="logo"
            className="w-[40px] pt-[4px] mx-auto"
          />
        )}

        <Text elementType="h2" color="text" className="text-[18px] mt-3 font-medium">
          home.modal.AIModels
        </Text>
        <Text elementType="h3" color="text" className="text-[14px] mt-2" fontWeight={200}>
          home.modal.description
        </Text>
        <div className="overflow-x-auto" dir={direction}>
          <table
            className="w-full table-auto max-w-[950px] xs:whitespace-nowrap md:whitespace-normal mx-auto mt-[30px] mb-[10px] text-[14px] font-medium"
            style={{ color: theme.text }}
            dir={direction}
          >
            <thead>
              <tr>
                <Text elementType="th" className="py-2 px-4">
                  home.modal.title
                </Text>
                <Text elementType="th" className="py-2 px-4 text-center">
                  home.modal.model
                </Text>
                <Text elementType="th" className="py-2 px-4 text-center">
                  home.modal.price
                </Text>
                <Text elementType="th" className="py-2 px-4">
                  home.modal.suitableFor
                </Text>
              </tr>
            </thead>
            <tbody className="text-right text-sm">
              {third_party_models?.map((item: GetModelListDataTypes) => (
                <tr key={item.id} className="border-t">
                  <td className="py-3 px-4 w-[160px] h-full text-center">
                    <div className="flex  xs:py-3 md:py-0">
                      <img
                        alt="logo"
                        className="w-[16px] me-2"
                        src={themeStatus === "dark" ? item?.icon_link_dark : item?.icon_link_light}
                      />
                      <Text elementType="span" fontWeight={500}>
                        {item?.sub_service_title}
                      </Text>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-center w-[150px]">
                    <div className="flex items-center justify-center">
                      <Text elementType="span" fontWeight={400}>
                        {item?.model}
                      </Text>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-center w-[150px]">
                    {item?.cost_status === "free" ? (
                      <Div
                        className="w-[40px] mx-auto h-[24px] rounded-[5px] flex justify-center items-center"
                        bg="showInfoFile"
                      >
                        <Text elementType="span" className="text-xs" fontWeight={300} color="text">
                          free
                        </Text>
                      </Div>
                    ) : (
                      <div
                        className={`flex items-center justify-center ${!has_subscription ? "pointer" : ""}`}
                        onClick={navigateToSubscription}
                      >
                        <Icon Component={Home3} color="tokenIcon" size={16} className="me-1" />
                        <Text elementType="span" color="tokenIcon" fontSize={10}>
                          home.modal.tokenRequired
                        </Text>
                      </div>
                    )}
                  </td>
                  <td className="py-3 xs:px-0  md:px-[20px]">
                    <Text
                      elementType="p"
                      className="text-sm lr:text-left rl:text-right"
                      fontWeight={300}
                      lineHeight={"24px"}
                    >
                      {item?.sub_service_desc}
                    </Text>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Div>
    </Modal>
  );
};
